/**
 * Add Context Variable controller
 */

import * as contextVariableService from '../../data/services/contextVariableService';

/**
 * Add a new context variable
 * @param {Object} data - Context variable data
 * @param {string} data.title - Title
 * @param {string} data.context - Context text
 * @param {boolean} data.isGlobal - Whether it's global
 * @returns {Promise<Object>} Created context variable
 */
export const addContextVariable = async (data) => {
  try {
    const contextVariable = await contextVariableService.createContextVariable(data);
    return contextVariable.toJSON();
  } catch (error) {
    console.error('Error adding context variable:', error);
    throw error;
  }
};

